import React, { useState, useEffect, useRef } from "react";
import { getData } from "app/data";
import { useLocation, useParams } from 'react-router-dom';
import "../../ServiceRate.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faDollarSign } from '@fortawesome/free-solid-svg-icons';
import ServiceRateContent from "../../ServiceRateContent";
import { faQq } from "@fortawesome/free-brands-svg-icons";
import Faq from "../../../Faq";
import ContentsTwoColumn from "components/MerchantService/ContentsTwoColumn";

export default function Index() {
    const faqData = getData("serviceRatesIndustryFaqData");
    const contents = getData("browseByUseCaseData1");
    const location = useLocation();
    const dataName = location.pathname.split("/")[2].replaceAll("-", "_") + "_" + location.pathname.split("/")[3];
    return (
        <div>

            <ServiceRateContent name={dataName} type="industry" />
            <ServiceRateContent name="serviceRateIndustryPageData" />
            <ContentsTwoColumn data={contents} posName="browseByUseCase" />
            <Faq fromServiceRate={true} faqpost_en={faqData} faqpost_zh={faqData} />
        </div>


    );
}
